import { ALERT_SEVERITY, ALERT_STATUS, type AlertSeverityLevel, type AlertStatus } from '@tumin/domain'
import type { StatusTone } from '@/components/status-badge'

/** Permiso para resolver alertas. */
export const COMPLIANCE_MANAGE_PERMISSION = 'compliance:manage' as const
/** Permiso para exportar el RTE a CSV. */
export const EXPORT_PERMISSION = 'reports:export' as const
/** Nombre base del archivo del RTE. */
export const CASH_REGISTER_FILE_BASE = 'rte'

/** Tono de cada severidad. */
export const SEVERITY_TONES: Record<AlertSeverityLevel, StatusTone> = {
  [ALERT_SEVERITY.info]: 'info',
  [ALERT_SEVERITY.warning]: 'warning',
  [ALERT_SEVERITY.critical]: 'critical',
}
/** Tono de cada estado de alerta. */
export const ALERT_STATUS_TONES: Record<AlertStatus, StatusTone> = {
  [ALERT_STATUS.open]: 'warning',
  [ALERT_STATUS.dismissed]: 'neutral',
  [ALERT_STATUS.reported]: 'critical',
}
/** Severidades de la más a la menos grave (orden de los indicadores). */
export const SEVERITY_ORDER: readonly AlertSeverityLevel[] = [ALERT_SEVERITY.critical, ALERT_SEVERITY.warning, ALERT_SEVERITY.info]

/** Pestañas de cumplimiento. */
export const COMPLIANCE_TABS = ['alerts', 'cash-register', 'pep'] as const
/** Pestaña de cumplimiento. */
export type ComplianceTab = (typeof COMPLIANCE_TABS)[number]
